var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_3_694)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3_694",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3_694",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3_694",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEGUlEQVR4nO2dS2xUVRiAD4SCWNkQEl8R4tKAiAlRNlo1KFTaBRvjgqisQCK4kQAJuGgwgUQXhkQXallAagxrEkLCptGKBggTk0YgLMRHeENKfdRSPvOnp+lQZ6ZzO/e87v2/ZJKmac/9/69/z5x7z2OMURRFURRFURRFUe4HaAOeBDqAt4A9wKfAIeAo8D3wM3ARuGlfw0wyXPX9i/ZnB+zvHrJt7bFtd9hrtZkiAiwEXgA2AfuBr4Fvgd+AMfwzZq8tMfTZmDbZGBea2AHmA6uAzcAB4ARwmfS4bGM/YHN5XnILLfcBYCvwAzBKcRkFfgTel5x9S34cqFA+KpK7L8nzgLOUl7PiwIdo+RcqO9t8iJb+quyc9CH6z9BZRsCwD9EKoKI9oaI9oaI9oaI9oaI9oaI9oaI9oaI9oaKn5x9gB/CIfcnXI2RERU8vubPG3e5OMqKi6yNV213nscLDZERFZ5RsRT9GRlT0//m7VncxRfQuMqKis0vutH13JlR0k92FlbzG/jEyo6I9SBZUNO4l+xJ9l5JLBkbLPGc44kmyMORD9A1KNLqowzUfoi/QGv12Xdt7wCnSkyyc8yFaVmLOlD5gdlVbc4DexCQL/T5EH2khwCU12psNfJWQZOEbp5Jt8PtaWJvcVqfNrLKbkfy6I8nCR84EVyWwsYUAX27QbrOyQ0sW3nYid0oSz7UQ4DlgUQuyY5AsrHQit8ay3VYSGZSZjQbtzwI+m+E4eW1O4+RGSPtzncitkdDJHBZ0L8pQ2ZLc2ggqWRhwIrVOUj05BDzYZGXHUsn+3girEluZU9CVJir7mUgqeYIXnUhtUG2yjcy57Mgk3/C+VxH4PMcEBht1IxF0FxN84c5o/URfyzmJSrOVHaCSJ1jt3mzt7kO2BeOzsglTycL56uc0XpHdSQ4SGqwnO6BkYYt/w5OJLwBuO0iqIotaplyrK1B3IdwCHgom2gr4xFFyV+zpBO8AB4F7hOPjoJKrtitXH+9QNO7ISiYTA8CHFJfdJrJjJH6hePwKPGhiAthA8XjTxIYdVx+nOByTnEyM2OWv10mfa8CjJmaA9aTPGyYF7Lg3VXpNKtjzluQ4tdQ4Fd0oYzrsjqdLpMPv3s5Lyhvg2UTuGu9MN5MTPfIMF/iLeJHYXjFFAHg14OPNRsjE7zpTJAj7mLMWEkuXKSLAS46eX2dlSKbiTJEBlgYejfwBrDBlAFgMnA40Tn7ClAnGb2q+9Cj5cHI3I3kCvOt4+Cdtbw6dZxQATwFnHEj+CVgeOr+oYHw58F7g35zGxz3eltemCPC0Pat/pnwHLAudRzIA3fZDEprlkv3ghDhnRRLoTrbbGY96XAU+8HJ4dtEB2u3oZMCuGrpp9zvKJ060h45PURRFURRFURTFpMx//i/YKBJ/CYcAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtect);
export default __webpack_public_path__ + "static/media/Protect.9dff121596470e1f0c39cb27f0c5c3fb.svg";
export { ForwardRef as ReactComponent };